import React, {useEffect, useState, useCallback} from 'react';


import {useDispatch} from "react-redux";
import {toast} from "react-toastify";
import {formatErrors} from "../../constants";
import {permissionsAction, permissionDeleteAction} from '../../actions/rolesAction';
import {ButtonMore} from '../../utils/buttonMore/buttonMore';
import {ConfirmModal} from "../../utils/confirm/ConfirmModal";
import {Menu} from "../../utils/menu/Menu";
import {SortItem} from "../../utils/sortItem/SortItem";
import {Link} from "react-router-dom";


function Permissions() {

  return <div className="content">
    <Menu isStatic={true}/>

    <div className="heading heading--flex">
      <h2 className="heading__title">Разрешения</h2>
      <Link to="/permission/0" className="heading__btn heading__btn--invite btn modal-btn">+ Добавить разрешение</Link>
    </div>  
    {<PermissionsList />}
  </div>;
}


function PermissionsList() {
  const dispatch = useDispatch();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modules, setModules] = useState({});

  const deletePermission = (id) => {
    return new Promise((resolve, reject) => {
      if (loading) {
        return resolve(false);
      }
      setLoading(true);
      dispatch(permissionDeleteAction(id)).then(() => {
        setLoading(false);
        resolve(true);
        getList();
      }).catch(err => {
        setLoading(false);
        toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
        reject(err);
      });
    })
  };

  const getList = useCallback(() => {
    dispatch(permissionsAction()).then((res) => {
      setItems((res.list || []).filter(i => i.permission !== 'front'));
      setModules((res.list || []).filter(i => i.permission === 'front').reduce((acc, i) => {
        acc[i.module] = i.name;
        return acc;
      }, {}));
      console.log((res.list || []).filter(i => i.permission === 'front').reduce((acc, i) => {
        acc[i.module] = i.name;
        return acc;
      }, {}));
    }).catch(err => {
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  }, [dispatch]);

  useEffect(() => {
   getList();
  }, [getList]);

  return <React.Fragment>
    {items && <div className="users">
      <div className="users__wrapper">
        <div className="sort">
          <SortItem title="Название" className="sort__item--name"/>
          <SortItem title="Модуль" className="sort__item--name"/>
          <SortItem title="Путь" className="sort__item--name"/>
          <SortItem title="Разрешения" className="sort__item--name"/>
          <SortItem title="" className="sort__item--course"/>
        </div>
        <div className="users__inner">
          {items.map((i) => {
            return <div key={i.id} className="users__item">
              <span className="users__name">{i.name}</span>
              <span className="users__name">{[...new Set(i.module.split(',').map(m => m.split(':')[0]))].map(m => modules[m] || m).join(', ')}</span>
              <span className="users__name">{i.route_path}</span>
              <span className="users__name">{i.permission.split(',').map(p => 
                p.trim() === 'read' ? 'Чтение' :
                p.trim() === 'update' ? 'Запись' : 
                p.trim() === 'delete' ? 'Удаление' :
                p.trim()
              ).join(', ')}</span>
              
              <ButtonMore>
                <ul className="dropdown">
                  <li className="dropdown__item icon-delete">
                    <Link to={'/permission/' + i.id}>Редактировать</Link>
                  </li>
                  <li className="dropdown__item icon-delete">
                    <ConfirmModal trigger={<span>Удалить</span>} triggerWrap={false} title={"Удалить разрешение?"} handleOk={() => deletePermission(i.id)}/>
                  </li>
                </ul>
              </ButtonMore>
            </div>;
          })}
        </div>
      </div>
    </div>}
  </React.Fragment>;
}

export default Permissions
